import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AdminService } from "../../services";
import { injectModels } from "../../redux/injectModels";

const DashboardImages = () => {
  const history = useHistory();
  const [remainingDays, setRemainingDays] = useState(null);
  const [loading, setLoading] = useState(false);

  const user_id = localStorage.getItem("user_id");
  const tier = localStorage.getItem("tier");
  const tier_health = localStorage.getItem("tier_health");

  useEffect(() => {
    console.log("DashboardImages Mounted");
    const fetchUserDetails = async () => {
      try { 
        setLoading(true);
        const response = await AdminService.getUserDetails(user_id);

        if (response && response.remaining_days !== null) {
          setRemainingDays(response.remaining_days);
        }
      } catch (error) {
        console.log("Error fetching user details:", error);
      }
      setLoading(false);
    };

    fetchUserDetails();
    return () => {
      console.log("DashboardImages Unmounted");
    }
  }, []);

  const allServices = [
    {
      id: 1,
      icon: "fa-user-doctor",
      redirect: "/gp-appointments",
      external: false,
      label: "Click here for GP Appointments",
      key: "gp",
    },
    {
      id: 2,
      icon: "fa-heart-pulse",
      redirect: "/wellbeing-services",
      external: false,
      label: "Click here for Wellness",
      key: "wellness",
    },
    {
      id: 3,
      image: "/assets/img/travel2.png",
      redirect: "https://bookings.2tiertravel.com/",
      external: true,
      label: "Click here for Members Discounted Travel",
      key: "travel",
    },

    {
      id: 4,
      image: "/assets/img/randox.png", 
      redirect: "https://randox.gewardzhealth.com/",
      external: true,
      label: "Click here for Randox Health",
      key: "randox",
    },
  ];

  const filterServicesByTier = () => {
    let filtered = [...allServices];

    if (tier_health === "0") {
      filtered = filtered.filter((s) => s.key !== "travel");
    }
    switch (tier) {
      case "Tier1":
        return filtered.filter((s) => ["wellness", "travel" ,"randox"].includes(s.key));

      case "Tier2":
        return filtered.filter((s) => ["gp", "travel"].includes(s.key));

      case "Tier3":
        return filtered.filter((s) =>
          ["gp", "wellness", "travel"].includes(s.key)
        );

      case "Tier4":
        return filtered;

      default:
        return filtered;
    }
  };

  const services = filterServicesByTier();

  // ⭐ Add Remaining Days card
  if (remainingDays !== null) {
    services.push({
      id: 4,
      icon: "fa-calendar-day",
      redirect: "#",
      external: false,
      label: `Remaining Days: ${remainingDays}`,
      isStatic: true,
    });
  }

  const handleRedirect = (service) => {
    if (service.isStatic) return;
    if (service.external) window.open(service.redirect, "_blank");
    else history.push(service.redirect);
  };

  return (
    <>
      <style>
        {`
          .cards-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 30px;
            padding: 60px 20px;
          }

          .service-card {
            background-color: #ffffff;
            border-radius: 12px;
            width: 200px;
            height: 180px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding: 25px 15px;
            text-align: center;
            cursor: pointer;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
            border-bottom: 3px solid #61bef5;
            transition: transform 0.2s ease;
          }

          .service-card:hover {
            transform: translateY(-4px);
          }

          .service-card img {
            width: 70px;
            height: 70px;
            object-fit: contain;
          }

          .service-card i {
            font-size: 55px;
            color: #61bef5;
          }

          .service-card span {
            font-size: 14px;
            font-weight: 600;
            color: #333;
            margin-top: 15px;
            line-height: 1.3;
          }

       @media (max-width: 768px) {

            .cards-container {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 15px; 
              padding: 40px 20px; /* 60 se 40 kiya only */
            }

            /* Reduce size but don't break layout */
            .service-card {
              width: 45%;     /* ⭐ side-by-side GP + Wellness */
              height: 150px;
              padding: 15px;
            }

            .service-card i,
            .service-card img {
              width: 45px !important;
              height: 45px !important;
              font-size: 40px !important;
            }

            .service-card span {
              font-size: 12px;
            }
          }
        `}
      </style>

      <div className="cards-container">
        {services.map((service) => (
          <div
            key={service.id}
            className="service-card"
            onClick={() => handleRedirect(service)}
            style={service.isStatic ? { cursor: "default" } : {}}
          >
            {service.image ? (
              <img src={service.image} alt={service.label} />
            ) : (
              <i className={`fa-solid ${service.icon}`}></i>
            )}
            <span>{service.label}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default injectModels(["auth"])(DashboardImages);
